import OrderCancelRevertRequestRequest from "../../../../api/raily/order/cancel/revert-request/order-cancel-revert-request.request";
import OrderCancelRevertRequestParams from "./order-cancel-revert-request-params";

const create = (
  params: OrderCancelRevertRequestParams,
): OrderCancelRevertRequestRequest => {
  return {
    orderId: params.orderUuid,
  };
};

const orderCancelRevertRequestParamsFactory = {
  create,
};

export default orderCancelRevertRequestParamsFactory;
